import { render, staticRenderFns } from "./actMaleMain.vue?vue&type=template&id=f31e7278&scoped=true"
import script from "./actMaleMain.vue?vue&type=script&lang=js"
export * from "./actMaleMain.vue?vue&type=script&lang=js"
import style0 from "./actMaleMain.vue?vue&type=style&index=0&id=f31e7278&prod&lang=less&scoped=true"
import style1 from "./actMaleMain.vue?vue&type=style&index=1&id=f31e7278&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31e7278",
  null
  
)

export default component.exports